export const ADD_PRODUCT = "ADD_PRODUCT";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const GET_PRODUCTS_BY_COUNTRYCODE = "GET_PRODUCTS_BY_COUNTRYCODE";
export const ADD_PRODUCT_PROPERTIES = "ADD_PRODUCT_PROPERTIES";
export const UPDATE_PRODUCT_PROPERTIES = "UPDATE_PRODUCT_PROPERTIES";
export const GET_PRODUCTPROP = "GET_PRODUCTPROP";
export const DELETE_PRODUCT_PROPERTIES = "DELETE_PRODUCT_PROPERTIES";
export const GET_PRODUCTS_BY_ID = "GET_PRODUCTS_BY_ID";
export const CLEAR_PRODUCTS_BY_ID = "CLEAR_PRODUCTS_BY_ID";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const ADD_PROPERTY = "ADD_PROPERTY";
export const UPDATE_PROPERTY = "UPDATE_PROPERTY";
export const DELETE_PROPERTY = "UPDATE_PROPERTY";
export const GET_ALL_PROPERTIES = "GET_ALL_PROPERTIES";
export const GET_CLIENTS_BY_COUNTRYCODE = "GET_CLIENTS_BY_COUNTRYCODE";
export const GET_ADS = "GET_ADS";
// Link the product to the current website
export const LINK_PRODUCT = "LINK_PRODUCT";
// push clikout url + product img to the store ( product page -> redirect page)
export const PUSH_CLICKOUT = "PUSH_CLICKOUT";
// clear clikout url + product img from the store ( product page -> redirect page)
export const CLEAR_CLICKOUT = "CLEAR_CLICKOUT";
// Add a label for a property for a the current website
export const PATCH_PROPERTY = "PATCH_PROPERTY";
